module.exports = __webpack_public_path__ + "e5ed300cbf8440333531e7754220763d.svg";